/**************************************************************************************************/
/** @import Node Packages                                                                        **/
/**************************************************************************************************/
import { defineComponent } from 'vue'

/**************************************************************************************************/
/** @import Mixins                                                                               **/
/**************************************************************************************************/
import MixinResponsive from '@/Mixins/MixinResponsive'

/**************************************************************************************************/
/** @internal Const @name LoginHeader                                                            **/
/**************************************************************************************************/
const LoginHeader = defineComponent(
{
	/*************************************************/
	/** @Properties                                 **/
	/*************************************************/
	name: 'LoginHeader', mixins: [MixinResponsive]
})

/**************************************************************************************************/
/** @export Component @name LoginHeader                                                          **/
/**************************************************************************************************/
export default LoginHeader

/**************************************************************************************************/
/** @export Type @name LoginHeaderRef                                                            **/
/**************************************************************************************************/
export type LoginHeaderRef = InstanceType<typeof LoginHeader>